import baseService from '@/utils/http/axios'
// 移除baseURL导入，避免手动拼接导致的路径问题
import { baseURL } from '@/utils/util'
import { encryptByMd5 } from '@/utils/encrypt'
import { API } from './types'
import { getLocale } from '@antv/g2plot/lib/core/locale';
// 模拟的目标数据结构（作为映射模板）
const mockUserInfo = {
  "id": "4291d7da9005377ec9aec4a71ea837f",
  "name": "admin",
  "username": "LVQ",
  "password": "",
  "avatar": "/user.png",
  "status": 1,
  "telephone": "",
  "lastLoginIp": "27.154.74.117",
  "lastLoginTime": 1534837621348,
  "creatorId": "admin",
  "createTime": 1497160610259,
  "merchantCode": "TLif2btpzg079h15bk",
  "deleted": 0,
  "permission": [
    "admin"
  ],
  "token": "12312312",
  "menu": [
    {
      "name": "dashboard",
      "parentId": 0,
      "id": 1,
      "meta": {
        "icon": "bx-analyse",
        "title": "仪表盘",
        "show": true
      },
      "component": "RouteView",
      "redirect": "/dashboard/workplace"
    },
    {
      "name": "workplace",
      "parentId": 1,
      "id": 7,
      "meta": {
        "title": "工作台",
        "show": true
      },
      "component": "Workplace"
    }
  ]
};
// 直接使用相对路径，由baseService和代理自动处理完整地址
// api/user.ts 正确写法
export const userLogin = async (data,req) => {
    const clientIp = getClientIp(req); 
    const password=encryptByMd5(data.pass);
    try {
      // 调用真实接口
      const response = await baseService.post('/api/user/login/', data);
      // 注意：新结构中实际用户数据在 response.data.data.result 里
      const originalData = response.data?.result || {};
      const apiResponse = response.data; // 保留接口的状态和消息
      if(response.status<0){
        const transformedData = {
          code: 403,
          msg: response.status + ',' + response.message          
        }
        return transformedData;
      }
      // 将原始数据映射到目标格式
      const transformedData = {
        // 从 result 中提取字段
        id: originalData.UserID || mockUserInfo.id,
        name: originalData.Name || mockUserInfo.name,
        username: originalData.Code || mockUserInfo.username,
        password:password|| mockUserInfo.password,
        avatar: mockUserInfo.avatar,
        status: originalData.islogin ? 1 : 0,
        telephone: originalData.phone || mockUserInfo.telephone,
        lastLoginIp:clientIp ,
        lastLoginTime: Date.now(),
        creatorId: mockUserInfo.creatorId,
        createTime: mockUserInfo.createTime,
        merchantCode: mockUserInfo.merchantCode,
        deleted: mockUserInfo.deleted,
        permission: mockUserInfo.permission,
        token: originalData.token || mockUserInfo.token,
        menu: mockUserInfo.menu,
        deptname: originalData.DeptName || mockUserInfo.DeptName,
        unitname: originalData.UnitName || mockUserInfo.UnitName,
        // 保留接口返回的状态和消息（可选）
        code: apiResponse.status,
        msg: apiResponse.message
      };
      return transformedData;
    } catch (error) {
      return Promise.reject(error);
    }


};

export const userLogin2: API._Login = data => {
  const api = baseURL + `auth/login`
  return baseService.post(api, data)
}

export const getSmsCaptcha: API._GetSmsCaptcha = data => {
  return baseService.post('/api/account/sms', data)
}

export const get2step: API._Get2Step = () => {
  return baseService.get('/api/auth/2step-code')
}

export const logout: API._Logout = () => {
  return new Promise(resolve => {
    // setTimeout(() => {
      console.log('模拟退出登录成功');
      resolve(true); // 模拟成功
    // }, 500);
  });
  // return true// baseService.get('/api/auth/logout')
  // return baseService.get('/api/auth/logout')
}

// 辅助函数：从请求对象中提取客户端IP（兼容代理环境）
function getClientIp(req) {
  if (!req) return '';
  
  // 优先从代理头获取（如果使用了Nginx等代理）
  const proxyIp = req.headers['x-forwarded-for'] || 
                  req.headers['x-real-ip'] || 
                  req.connection.remoteAddress;
  
  // 处理多个代理的情况（取第一个IP）
  if (proxyIp && typeof proxyIp === 'string') {
    return proxyIp.split(',')[0].trim();
  }
  
  // 直接从请求对象获取（非代理环境）
  return req.ip || req.connection.remoteAddress || '';
}
export interface States {
  rememberMe: boolean;
  username: string;
  password: string;
  mobile: string;
  captcha: string;
}
